import { Filter } from 'iconsax-react';
import PropTypes from 'prop-types';
import Text from '../../../../assets/styles/Text';
import * as styles from './styles';

export default function Top({
  city,
  allModels,
  activeFiltersCount,
  setShowFilters,
}) {
  return (
    <styles.GroupTitle>
      <div>
        <Text.H4>
          Pesquisando por:{' '}
          <b>
            {city?.name || 'Carregando...'} - {city?.stateAc || ''}
          </b>
        </Text.H4>
        <Text.Span>
          <b>Modelos encontradas:</b> {allModels.length}
        </Text.Span>
      </div>

      <styles.HeaderButtons $active={activeFiltersCount > 0}>
        <button type="button" onClick={() => setShowFilters(true)}>
          <Filter size={20} />
          <Text.H4>Filtros</Text.H4>
          {activeFiltersCount > 0 && (
            <span className="badge">{activeFiltersCount}</span>
          )}
        </button>
      </styles.HeaderButtons>
    </styles.GroupTitle>
  );
}

Top.propTypes = {
  city: PropTypes.any.isRequired,
  allModels: PropTypes.any.isRequired,
  activeFiltersCount: PropTypes.any.isRequired,
  setShowFilters: PropTypes.any.isRequired,
};
